import ExcelJS from "exceljs";
import { saveAs } from "file-saver";

const generateLoanDisbursementSummaryExcel = async (data, branches, startDate, endDate, loginPlaceId) => {

  const workbook = new ExcelJS.Workbook();
  const worksheet = workbook.addWorksheet("Loan Disbursement Summary");
  const totalColumns = 1 + branches.length * 10;
  const categories = ["Below 100K", "100k to 250k", "250k to 500k", "500k to 1M", "Above 1M"];
  const categoryFields = [
    ["countBelow100K", "sumBelow100K"],
    ["count100Kto250K", "sum100Kto250K"],
    ["count250Kto500K", "sum250Kto500K"],
    ["count500Kto1M", "sum500Kto1M"],
    ["countAbove1M", "sumAbove1M"]
  ];

  worksheet.mergeCells(1, 1, 1, totalColumns);
  const titleCell = worksheet.getCell(1, 1);
  titleCell.value = `Loan Disbursement Summary Audit Report ${startDate} to ${endDate}`;
  titleCell.font = { bold: true, size: 16 };
  titleCell.alignment = { horizontal: "center", vertical: "middle" };
  worksheet.getRow(1).height = 25;

  let col = 2;
  branches.forEach((branch) => {
    worksheet.mergeCells(3, col, 3, col + 9);
    const cell = worksheet.getCell(3, col);
    cell.value = branch.branchName;
    cell.font = { bold: true, size: 14 };
    cell.alignment = { horizontal: "center", vertical: "middle" };
    col += 10;
  });
  worksheet.getRow(3).height = 20;

  col = 2;
  branches.forEach(() => {
    categories.forEach((category) => {
      worksheet.mergeCells(4, col, 4, col + 1);
      const cell = worksheet.getCell(4, col);
      cell.value = category;
      cell.font = { size: 10 };
      cell.alignment = { horizontal: "center", vertical: "middle" };
      col += 2;
    });
  });

  worksheet.getCell(5, 1).value = "Product";
  worksheet.getCell(5, 1).font = { size: 10 };
  worksheet.getCell(5, 1).alignment = { horizontal: "center", vertical: "middle" };

  col = 2;
  branches.forEach(() => {
    for (let i = 0; i < 5; i++) {
      ["Count", "Sum"].forEach((label) => {
        const cell = worksheet.getCell(5, col++);
        cell.value = label;
        cell.font = { size: 10 };
        cell.alignment = { horizontal: "center", vertical: "middle" };
      });
    }
  });

  let row = 6;
  data.forEach((product) => {
    col = 1;
    const cell = worksheet.getCell(row, col++);
    cell.value = product.productName;
    cell.alignment = { horizontal: "left", vertical: "middle" };
    cell.font = { size: 10 };

    branches.forEach(() => {
      categoryFields.forEach(([countField, sumField]) => {
        const countCell = worksheet.getCell(row, col++);
        countCell.value = product[countField] || 0;
        countCell.numFmt = "#,##0";
        countCell.alignment = { horizontal: "right", vertical: "middle" };
        countCell.font = { size: 10 };

        const sumCell = worksheet.getCell(row, col++);
        sumCell.value = parseFloat(product[sumField]) || 0;
        sumCell.numFmt = "#,##0";
        sumCell.alignment = { horizontal: "right", vertical: "middle" };
        sumCell.font = { size: 10 };
      });
    });
    row++;
  });

  col = 1;
  const totalCell = worksheet.getCell(row, col++);
  totalCell.value = "Total";
  totalCell.font = { bold: true, size: 10 };
  totalCell.alignment = { horizontal: "left", vertical: "middle" };

  branches.forEach(() => {
    categoryFields.forEach(([countField, sumField]) => {
      let totalCount = 0, totalSum = 0;
      data.forEach((product) => {
        totalCount += product[countField] || 0;
        totalSum += parseFloat(product[sumField]) || 0;
      });

      const countCell = worksheet.getCell(row, col++);
      countCell.value = totalCount;
      countCell.numFmt = "#,##0";
      countCell.font = { size: 10 };
      countCell.alignment = { horizontal: "right", vertical: "middle" };

      const sumCell = worksheet.getCell(row, col++);
      sumCell.value = totalSum;
      sumCell.numFmt = "#,##0";
      sumCell.font = { size: 10 };
      sumCell.alignment = { horizontal: "right", vertical: "middle" };
    });
  });

  worksheet.getColumn(1).width = 25;
  for (let i = 2; i <= totalColumns; i++) {
    worksheet.getColumn(i).width = 15;
  }

  const borderStyle = {
    top: { style: "thin" },
    left: { style: "thin" },
    bottom: { style: "thin" },
    right: { style: "thin" }
  };

  worksheet.getCell(1, 1).border = borderStyle;
  for (let r = 3; r <= row; r++) {
    for (let c = 1; c <= totalColumns; c++) {
      worksheet.getCell(r, c).border = borderStyle;
    }
  }

  if (loginPlaceId === "1") {
    worksheet.protect("12345");
  }

  const buffer = await workbook.xlsx.writeBuffer();
  const blob = new Blob([buffer], {
    type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
  });
  saveAs(blob, `Loan_Disbursement_Summary_Report.xlsx`);
};

export default generateLoanDisbursementSummaryExcel;
